module.exports = __webpack_public_path__ + "static/media/Potra.4c166a66.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/libs/fonts/Potra.ttf
// module id = 158
// module chunks = 0